exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-box .my-input[data-v-db5cb742] {\n  max-width: 215px;\n}\n.my-box .el-row[data-v-db5cb742] {\n  margin-bottom: 10px;\n}\n.my-box .el-row[data-v-db5cb742]:last-child {\n    margin-bottom: 0;\n}\n.my-box .el-col[data-v-db5cb742] {\n  border-radius: 4px;\n}\n", ""]);

// exports
